
import { BasePage } from "./BasePage";

import type { PageTemplateProps } from "./types";

// Onboarding - mirrors the Partnership template surface: a single gdoc_embed
// widget hosting the per-supplier copy of the Onboarding Intake template doc.
// Visibility is gated upstream (see pageSchema.hidden) - this page is provisioned
// onto every room but only revealed once the Pipedrive deal hits the lifecycle
// pivot from prospect to onboarding (Contracting stage). The /personalize-onboarding-intake
// sub-skill creates the per-supplier copy and writes its URL into the gdoc_embed.
export function Onboarding(props: PageTemplateProps) {
    return <BasePage {...props} />;
}
